// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"36":"972c806a","67":"65fccc5f","75":"e5f2607d","293":"0c419866","425":"7760cc08","432":"85ab2eed","902":"ad4f17dc"}[chunkId] + ".js";
};